var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDelegate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.927,33.926l-6.875,6.875-2.592-2.592,5.042-5.042h-6.417c-2.528,0-4.584,2.055-4.584,4.583v8.25h-3.667v-8.25c0-4.548,3.702-8.25,8.25-8.25h6.417l-5.042-5.042,2.592-2.592,6.875,6.875c1.43,1.428,1.43,3.756,0,5.185ZM5.667,13c0-6.067,4.934-11,11-11s11,4.933,11,11-4.934,11-11,11-11-4.933-11-11ZM22.168,37.75c0-3.738,1.731-7.08,4.433-9.266-1.071-.51-2.253-.818-3.516-.818h-12.834c-4.549,0-8.25,3.702-8.25,8.25v10.083h20.168v-8.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelegate);
export default __webpack_public_path__ + "static/media/icon-delegate.5702bec60b72cb70a54ac39ea771804d.svg";
export { ForwardRef as ReactComponent };